module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": '#fff'
    }
  }) : _c('table', {
    staticClass: "do-table do-table__items"
  }, [_c('thead', [_c('th', [_vm._v("Omkostningssteder")]), _vm._v(" "), _c('th', [_vm._v("Kode")]), _vm._v(" "), _c('th', [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.setIsCreateItemModal(true)
      }
    }
  }, [_vm._v("\n        Opret omkostningssted\n      ")])])]), _vm._v(" "), _c('tbody', [(_vm.items.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('i', [_vm._v("Ingen oprettet")])]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', {
      key: item.code
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('td')])
  })], 2)]), _vm._v(" "), (_vm.isCreateItemModal) ? _c('TableCreateModal', {
    attrs: {
      "theEditItem": _vm.theEditItem,
      "isSubmitting": _vm.isSubmitting,
      "isDeleting": _vm.isDeleting
    },
    on: {
      "onSubmit": _vm.onCreate,
      "close": _vm.setIsCreateItemModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68922777!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SchoolSettings/CostCenters.vue
// module id = 1691
// module chunks = 1